import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import {
  TREQUEST_DELETE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY,
  TREQUEST_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TRESPONSE_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
} from '@monorepo/types';
import { select, Store } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { catchError, finalize, switchMap, take, tap } from 'rxjs/operators';
import { TPlani8State } from '../reducers';
import * as FactoryProductLineEfficiencyActions from './product-line-efficiency.actions';
import * as FactoryProductLineEfficiencySelectors from './product-line-efficiency.selectors';

@Injectable({
  providedIn: 'root',
})
export class FactoryProductLineEfficiencyFacade {
  constructor(
    private store: Store<TPlani8State>,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  fetchFactoryProductLineEfficiency(factoryId: string, payload: TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY) {
    this.store.dispatch(new FactoryProductLineEfficiencyActions.GetFactoryProductLineEfficiency(factoryId, payload));
  }

  getFactoryProductLineEfficiency() {
    return this.store.pipe(select(FactoryProductLineEfficiencySelectors.getFactoryProductLineEfficieny));
  }

  updateFactoryProductLineEfficiency(
    factoryId: string,
    updatePayload: TREQUEST_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
    fetchPayload: TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY,
  ): Observable<TRESPONSE_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES | null> {
    return from(this.appNotificationUtilClass.presentLoading()).pipe(
      take(1),
      switchMap((loaderEl) =>
        this.plani8DataService.updateFactoryProductLineEfficiency(factoryId, updatePayload).pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
          }),
          tap(() =>
            this.store.dispatch(
              new FactoryProductLineEfficiencyActions.GetFactoryProductLineEfficiency(factoryId, fetchPayload),
            ),
          ),
          catchError((error) => {
            return of(null);
          }),
        ),
      ),
    );
  }

  deleteFactoryProductLineEfficiency(
    factoryId: string,
    deletePayload: TREQUEST_DELETE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
    fetchPayload: TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY,
  ) {
    this.store.dispatch(
      new FactoryProductLineEfficiencyActions.DeleteFactoryProductLineEfficiency(
        factoryId,
        deletePayload,
        fetchPayload,
      ),
    );
  }
}

export type TGetFactoryProductLineEffiency = ReturnType<
  FactoryProductLineEfficiencyFacade['getFactoryProductLineEfficiency']
>;
